











































import { Component, mixins } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import Tooltip from '@/modules/shared/components/shared/kit/BaseTooltip.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import QTable from 'quasar/src/components/table/QTable.js';
import { FaqCollectionType } from '@/modules/faq/models/faq-collection.model'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import PanelLayout from '@/modules/common/layout/components/panel/PanelLayout.vue'

@Component({
  layout: PanelLayout,
  layoutProps: {
    page_header: 'سوالات متداول',
    page_sub_header: 'در این بخش می توانید سوالات متداولی که توسط مشتریان و مخاطبان پرسیده می شود را مشاهده نمائید'
  },
  metaInfo: {
    title: 'سوالات متداول'
  },
  components: {
    FilterRow,
    BaseInput,
    BaseButton,
    Tooltip
  }
})
export default class FaqPage extends mixins(QsSearchableMixin) {
  @Prop() faqs!: FaqCollectionType

  private faqsColumn: QTable['columns'] = [
    {
      name: 'question',
      label: 'عنوان سوال',
      field: 'question',
      align: 'left'
    }
  ]
}
